import { Dialog, DialogContent, IconButton, styled, Backdrop } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import CorrectionForm from './CorrectionForm';

const BackdropBlur = styled(Backdrop)({
    backdropFilter: 'blur(6px)',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
});

const CorrectionModal = ({ id, onClose, onSuccess, onError }) => (
    <Dialog
        open
        onClose={onClose}
        fullWidth
        maxWidth="xs"
        slots={{ backdrop: BackdropBlur }}
        slotProps={{ paper: { sx: { borderRadius: '8px', padding: '48px 36px 24px' } } }}
    >
        <IconButton onClick={onClose} sx={{ position: 'absolute', top: 12, right: 12 }}>
            <CloseIcon />
        </IconButton>

        <DialogContent sx={{ padding: '0px' }}>
            <CorrectionForm onSuccess={onSuccess} id={id} onClose={onClose} onError={onError} />
        </DialogContent>
    </Dialog>
);

export default CorrectionModal;
